export enum menuAncresEnum {
	DESCRIPTIF = 'descriptif',
	LOYER = 'loyer',
	QUARTIER = 'quartier',
	RESIDENCE = 'residence'
}